// utils/relatorios/obterDestinoRelatorio.js

const CAMPOS_AUDITORIA = ['createdAt', 'updatedAt', 'deletedAt'];

const DESTINOS_AUDITORIA_POR_MODULO = {
    movimento: {
        url: 'auditoria',
        caminho: 'movimento/relatorio-auditoria',
    },

    lancamento: {
        url: 'lancamento',
        caminho: 'lancamento/relatorio-auditoria',
    },
};

const possuiValorFiltro = (valor) => {
    if (Array.isArray(valor)) {
        return valor.some((item) => item !== null && item !== undefined && item !== '');
    }

    return valor !== null && valor !== undefined && valor !== '';
};

const possuiFiltroDeAuditoria = (filtros = []) =>
    filtros.some((filtro) => CAMPOS_AUDITORIA.includes(filtro?.id) && possuiValorFiltro(filtro?.value));

export const obterDestinoRelatorio = (relatorio, filtros = []) => {
    const destinoPadrao = {
        caminho: relatorio.caminho,
        url: relatorio.url,
        auditoria: false,
    };

    const auditoria = relatorio?.auditoria;

    if (!auditoria?.habilitada || !auditoria?.modulo) {
        return destinoPadrao;
    }

    if (!possuiFiltroDeAuditoria(filtros)) {
        return destinoPadrao;
    }

    const destinoAuditoria = DESTINOS_AUDITORIA_POR_MODULO[auditoria.modulo];

    if (!destinoAuditoria) {
        return destinoPadrao;
    }

    return {
        ...destinoAuditoria,
        auditoria: true,
        modulo: auditoria.modulo,
    };
};
